module.exports = __webpack_public_path__ + "images/external_images/svg/icons/030-warning.svg";